import { Council } from "./../../services/council";

export const state = {
  councils: []
};

export const mutations = {
  SET_COUNCILS(state, councils) {
    councils.filter(c => {
      c.text = c.name;
      c.value = c.id;
    });
    state.councils = councils;
  }
};

export const getters = {
  councils(state) {
    return state.councils;
  },
  councilOptions(state) {
    return state.councils.map(council => ({
      label: council.name,
      value: council.id
    }));
  }
};

export const actions = {
  fetchAllCouncils({ commit }) {
    return Council.all()
      .then(response => {
        commit("SET_COUNCILS", response.data);
        return response;
      })
      .catch(errors => errors);
  }
};
